import { SocketEventType } from '@/modules/core/app/constants/SocketEventType';
import { UserSocketEvent } from '@/modules/core/app/events/UserSocketEvent';

export class AsyncRequestJobCompleteSocketEvent extends UserSocketEvent {
  requestId: string;

  constructor(model: AsyncRequestJobCompleteSocketEvent) {
    super(model);

    this.requestId = model.requestId;
  }

  static getEventName(): string {
    return SocketEventType.ASYNC_REQUEST_JOB_COMPLETE_SOCKET_EVENT;
  }
}
